import template from './filterSelect.html';
import controller from './filterSelect.controller';
import './filterSelect.scss';

let filterSelectComponent = {
  restrict: 'E',
  bindings: {
    options: '<',
    value: '=',
    label: '@',
    current: '<',
    changed: '&'
  },
  template,
  controller
};

export default filterSelectComponent;
